(function ($) {
    $(document).ready(function () {

        let observer, $nextPage;
        initInfiniteScroll();

        $(document).on('init-infinite-scroll', initInfiniteScroll);

        function initInfiniteScroll() {
            if (observer) observer.disconnect();

            $nextPage = $('.woocommerce-pagination .page-numbers.next');
            if (!$nextPage.length) return;

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadNextPage();
                    }
                });
            });
            observer.observe($nextPage.get(0));
        }

        function loadNextPage() {
            if (observer) observer.disconnect();
            const url = $nextPage.attr('href');
            const $pagination = $('.woocommerce-pagination');

            $pagination.hide();
            const $loader = $(`<div class="text-center my-2 clear"><button disabled class="btn btn-primary">Chargement en cours...</button> </div>`).insertAfter($pagination);

            $.ajax({
                url,
                type: 'GET',
                contentType: 'application/json',
                dataType: 'html'
            }).done(function (data) {
                $pagination.show();
                $loader.remove();

                $('.products').append($('.products > *', data));
                const paginationHTML = $('.woocommerce-pagination', data);
                $pagination.html(paginationHTML);
                $(document).trigger('infinite-scroll-loaded');

                if (!paginationHTML.has('.next').length) {
                    $pagination.remove();
                    return;
                }
                initInfiniteScroll();
            });
        }
    });

})(jQuery);
